import './Texts.css';
import { DeliveryItemText } from '../../../atomic/delivery_dialog/delivery_item_text/DeliveryItemText';
import { GiantNameText } from '../../../atomic/delivery_dialog/giant_name_text/GiantNameText';
import { LevelNameText } from '../../../atomic/delivery_dialog/level_name_text/LevelNameText';
import { OrderAnswerText } from '../../../atomic/delivery_dialog/order_answer_text/OrderAnswerText';
import { OrderRiddleText } from '../../../atomic/delivery_dialog/order_riddle_text/OrderRiddleText';
import { WhatInsideText } from '../../../atomic/delivery_dialog/what_inside_text/WhatInsideText';

export type DeliveryDialogTextsProps = {
  riddleText?: string;
  /** Отгадка; на success занимает слот описания вместо загадки. */
  answerText?: string;
  deliveryItemText?: string;
  showDeliveryItem?: boolean;
  levelNameText?: string;
  giantNameText?: string;
};

/** Figma texts: decription_text, level_name_text, giant_name_text, Что внутри. */
export function Texts({
  riddleText,
  answerText,
  deliveryItemText,
  showDeliveryItem = false,
  levelNameText,
  giantNameText,
}: DeliveryDialogTextsProps) {
  return (
    <>
      <LevelNameText text={levelNameText} />
      <GiantNameText text={giantNameText} />
      {answerText != null ? (
        <OrderAnswerText text={answerText} />
      ) : riddleText != null ? (
        <OrderRiddleText text={riddleText} />
      ) : null}
      <WhatInsideText />
      {showDeliveryItem && deliveryItemText != null ? (
        <DeliveryItemText text={deliveryItemText} />
      ) : null}
    </>
  );
}
